import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { Container, PageHeader, Spinner, EmptyState } from "@/components/common";
import { fileUrl } from "@/components/FileUpload";
import { Music, Clock, Facebook, Users } from "lucide-react";

export default function Instructors() {
  const { data: instructors, isLoading } = useQuery({ queryKey: ["instructors"], queryFn: async () => (await api.get("/instructors")).data });

  return (
    <div>
      <PageHeader eyebrow="Meet the team" title="Our instructors"
        subtitle="The friendly faces who'll teach you the ropes. Come and say hello at any of our classes — they love welcoming new dancers." />
      <Container className="py-10">
        {isLoading ? <Spinner /> : !instructors?.length ? (
          <EmptyState title="Instructors coming soon" subtitle="We're adding our team's profiles — check back shortly." icon={Users} />
        ) : (
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {instructors.map((it) => (
              <div key={it.id} data-testid={`instructor-card-${it.slug}`} className="flex flex-col overflow-hidden rounded-2xl border border-border bg-card">
                <div className="aspect-[4/5] w-full bg-[#EBE1D8]">
                  {it.photo_path ? (
                    <img src={fileUrl(it.photo_path)} alt={it.name} className="h-full w-full object-cover" />
                  ) : (
                    <div className="flex h-full w-full items-center justify-center text-[#C9B8AC]"><Users size={56} /></div>
                  )}
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <h3 className="font-display text-xl font-bold text-[#2D1E18]">{it.name}</h3>
                  {it.title && <p className="text-sm font-semibold uppercase tracking-wide text-[#B04B26]">{it.title}</p>}
                  {it.bio && <p className="mt-3 flex-1 whitespace-pre-line text-sm leading-relaxed text-[#5C4A42]">{it.bio}</p>}
                  <div className="mt-4 space-y-1.5 text-sm text-[#5C4A42]">
                    {it.favourite_dance && <p className="inline-flex items-center gap-2"><Music size={15} className="text-[#6E5B51]" /> Favourite dance: <span className="font-semibold">{it.favourite_dance}</span></p>}
                    {it.years_teaching && <p className="inline-flex items-center gap-2"><Clock size={15} className="text-[#6E5B51]" /> Teaching for {it.years_teaching}</p>}
                  </div>
                  {it.facebook_url && (
                    <a href={it.facebook_url} target="_blank" rel="noopener noreferrer" data-testid={`instructor-fb-${it.slug}`}
                      className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-[#B04B26] hover:underline"><Facebook size={15} /> Facebook</a>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </Container>
    </div>
  );
}
